<template>
    <div v-if="editedItem && editedItem.laonhfcInfo">
    <v-layout row wrap>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.vendor" label="廠牌"></v-text-field>
      </v-flex>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.name" label="車名"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.publicYear" label="出廠年"></v-text-field>
      </v-flex>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.publicMonth" label="出廠月"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.carId" label="車號"></v-text-field>
      </v-flex>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.cc" label="CC"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.vendor.totalCreditPrice" label="分期金額"></v-text-field>
      </v-flex>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.vendor.installmentsNumber" label="分期期數"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.vendor.creditPriceMonth" label="期付款"></v-text-field>
      </v-flex>
      <v-flex lg5 xs4 sm4 offset-xs1 offset-sm1 offset-lg1>
        <v-text-field v-model="editedItem.laonhfcInfo.engineId" label="車身號碼"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg6 xs10 sm10 offset-xs1 offset-sm1 offset-lg1>
        <v-textarea solo
                label="備註"
                v-model="editedItem.memo">
              </v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg6 xs12 sm12 offset-xs1 offset-sm1 offset-lg1>
        <div class="signBlue">
                <span class="s">申請人</span><br/>
                <img class="box" :src="signImageSrc('customer')"/>
                <div class="box"
                    style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
                    @click="showSignDialog('customer')"></div>
              </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg6 xs12 sm12 offset-xs1 offset-sm1 offset-lg1>
        <div class="signBlue">
            <span class="s">連帶保證人</span><br/>
            <img class="box" :src="signImageSrc('jointGuarantor')"/>
            <div class="box"
                 style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
                 @click="showSignDialog('jointGuarantor')"></div>
        </div>
      </v-flex>
    </v-layout>


    <v-layout row wrap>
      <v-flex lg3 md3 xs12 sm12 offset-xs2 offset-md2>
        <v-btn class="primary" dark text @click="save">儲存</v-btn>
      </v-flex>
      <v-flex lg3 md3 xs12 sm12 offset-xs2 offset-md2 >
        <v-btn color="error" dark text @click="ignore">略過</v-btn>
      </v-flex>
    </v-layout>

    <v-dialog
      fullscreen hide-overlay
      v-model="signDialog.visible">
      <v-card>
        <v-card-text>
          <draw-canvas :visible="signDialog.visible" :background-color="'#e6e6e6'" @handleDownloadSign="handleDownloadSign" @closeEvent="handleDownloadClose"></draw-canvas>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import DrawCanvas from '@/components/DrawCanvas';
import LaonhfcModel from '../models/LaonhfcModel';
import PaymentInfoModel from '../models/PaymentInfoModel';
import CaseInsureModel from '../models/CaseInsureModel';

export default {
  props: ['itemDetail', 'show'],
  name: 'UpdateMotorView',
  components: {  DrawCanvas },
  prop:{
    itemDetail:Object,
    show:Boolean
  },
  data() {
    return {
      saveLoading: false,
      loadingText: '上傳中...',
      signDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      editedItem: null,
    };
  },
  watch:{
    show(value){
      if (value === true){
        this.getItem();
      }
    }
  },
  created() {
    this.getItem();
  },
  mounted() {
  },
  computed: {

  },
  methods: {
    ...mapActions(['saveFinanceCreditData','fetchCreditProductInfo', 'uploadImageData']),
    signImageSrc(itemPath){
      let source = '';
      if (itemPath === 'customer'){
        if (this.editedItem.laonhfcInfo.signImage1) {
          source = this.editedItem.laonhfcInfo.signImage1;
        } else if(this.editedItem.laonhfcInfo.signimage1Url) {
          source = this.editedItem.laonhfcInfo.signimage1Url;
        }
      } else if(itemPath === 'jointGuarantor'){
        if (this.editedItem.laonhfcInfo.signImage2){
          source = this.editedItem.laonhfcInfo.signImage2;
        } else if(this.editedItem.laonhfcInfo.signimage2Url) {
          source = this.editedItem.laonhfcInfo.signimage2Url;
        }
      }
      return source;
    },
    async save(){
      console.log(`saveFinanceCreditData ${JSON.stringify(this.editedItem)}`);
      const result = await this.saveFinanceCreditData(this.editedItem);
      console.log(`saveFinanceCreditData ${JSON.stringify(result)}`);
      this.$emit('onFinishUpload', this.editedItem);
    },
    getItem(){
      this.fetchCreditProductInfo({ caseId: this.itemDetail.caseId })
      .then(async (results) => {
        if (results.length !== 0) { // 重複
          this.editedItem = results[0];
          if (!this.editedItem.laonhfcInfo){
            this.editedItem.laonhfcInfo = new LaonhfcModel();
          }
          if (!this.editedItem.paymentInfo){
            this.editedItem.paymentInfo = new PaymentInfoModel();
          }
          if (!this.editedItem.caseInsure){
            this.editedItem.caseInsure = new CaseInsureModel();
          }
        }
      });
    },
    ignore(){
      this.$emit('onFinishUpload', null);
    },
    showSignDialog(key){
      this.signKey = key;
      this.signDialog.visible = true;
    },
    async handleDownloadSign(image) {
      if (this.signKey === 'customer'  && image){
        this.editedItem.laonhfcInfo.signImage1 = image;
        if (image && image !== ''){
          this.editedItem.laonhfcInfo.signimage1Url = await this.uploadImageData({
            name: Math.uuidFast(),
            image: image,
          });
        }
      } else if (this.signKey === 'jointGuarantor' && image){
        this.editedItem.laonhfcInfo.signImage2 = image;
        if (image && image !== ''){
          this.editedItem.laonhfcInfo.signimage2Url = await this.uploadImageData({
            name: Math.uuidFast(),
            image: image,
          });
        }

      }
      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === 'customer'){
          this.editedItem.laonhfcInfo.signImage1 = image;
          if (image && image !== ''){
            this.editedItem.laonhfcInfo.signimage1Url = this.uploadImageData({
              name: Math.uuidFast(),
              image: image,
            });
          }

        } else if (this.signKey === 'jointGuarantor'){
          this.editedItem.laonhfcInfo.signImage2 = image;
          if (image && image !== ''){
            this.editedItem.laonhfcInfo.signimage2Url = this.uploadImageData({
              name: Math.uuidFast(),
              image: image,
            });
          }
        }
        this.signDialog.laonhfcInfo = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false
    },
  },
};

</script>
<style >
.signBlue {
  position: relative;
  float: left;
  width: 204px;
  height: 40px;
  border:1px solid #2b8bd8;
  padding-left: 5px;
  padding-top: 5px;
}
.signBlue span.s {
  display: inline-block;
  font-size: 10px;
  -webkit-transform: scale( 0.83 );
}
.signBlue .box {
  position: absolute;
  width: 125px;
  height: 35px;
  right: 2px;
  top: 2px;
  background: #e6e6e6;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UpdateMotorView.vue